let counter = 0;

/**
 * Per-instance DOM id for widgets that can be rendered more than once on a page
 * (the profession select sits both in the page and in the filter sidebar of
 * /jobs at the same time). Duplicate ids break every ARIA reference built from
 * them, so components must not hardcode one.
 */
export default function uniqueId(prefix: string): string {
  counter += 1;
  return `${prefix}-${counter}`;
}
